import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FCMClient from '../components/fragments/FCMClient';
import Screen from '../components/fragments/Screen';
import KanisaHomeCard from '../components/legacy/KanisaHomeCard';
import { activities } from '../store/local/contents';
import { rtGetListData } from '../store/slices/listSlice';

export default function HomeTab() {
    const dispatch = useDispatch();
    const state = useSelector((st) => st);
    const { token } = state.auth;

    useEffect(() => {
        token && dispatch(rtGetListData('announcements', 'announcements'));
        token && dispatch(rtGetListData('reminders', 'reminders'));
    }, [dispatch, token]);

    return (
        <Screen tab title="Activities">
            <FCMClient />
            {activities.map(({ icon, name, link, full, img }) => {
                return (
                    <KanisaHomeCard
                        key={`${name}`}
                        icon={icon}
                        title={name}
                        link={link}
                        img={img}
                        full={full}
                    />
                );
            })}
        </Screen>
    );
}
